import { newApiInstance } from 'functions/request';

export const getCategories = () => newApiInstance.get('/categories');
